import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String,
    mode: String,
    auto: Number
  }

  connect() {
    if (this.modeValue === "auto") {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.load()
          }
        })
      }, { rootMargin: "200px" })

      this.observer.observe(this.element)
    }
  }

  disconnect() {
    this.stopObserving()
  }

  load(event) {
    if (event) event.preventDefault()
    if (this.loading) return

    this.loading = true
    this.stopObserving()

    fetch(this.urlValue, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html, text/html"
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error("Ошибка загрузки")
        return response.text()
      })
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
      .catch(() => {
        this.showRetry()
      })
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  showRetry() {
    this.loading = false
    this.element.innerHTML = `
      <div class="flex flex-col items-center gap-2 py-4 text-gray-500">
        <p>Не удалось загрузить новости.</p>
        <button type="button" data-action="click->load-more#load" class="ds-btn ds-btn-secondary">
          Повторить
        </button>
      </div>
    `
  }
}
